import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { getHideElements, getShowStore } from '../../utils/apiv2';

import './BasicMenu.scss';

function BasicMenu({ authenticated, visible }) {
  const [hide, setHide] = useState([]);
  const [showStore, setShowStore] = useState(false);

  useEffect(() => {
    const hideElements = async () => {
      try {
        const data = await getHideElements();
        // Log the returned data for debugging
        if (data?.data?.[0]) {
          const startDate = new Date(data?.data?.[0]?.startDate);
          const endDate = new Date(data?.data?.[0]?.endDate);
          const today = new Date();
          const value = data?.data?.[0]?.value;

          if (startDate <= today && endDate >= today) {
            setHide(value);
          }
        }
      } catch (err) {
        console.error('Failed to fetch hide elements', err);
      }
    };

    const fetchShowStore = async () => {
      try {
        const data = await getShowStore();
        if (data?.data?.[0]?.value) {
          setShowStore(true);
        }
      } catch (err) {
        console.error('Failed to fetch show store setting', err);
      }
    };

    hideElements();
    fetchShowStore();
  }, []);

  if (!visible) return null;

  const Home = (
    <li className="menu-item">
      <Link
        activeClassName="active"
        onlyActiveOnIndex
        to="/"
      >
        Home
      </Link>
    </li>
  );

  // const AboutNoiz3 = (
  //   <li className="menu-item about-noiz-3">
  //     <Link
  //       activeClassName="active"
  //       to="/about-us-beta3"
  //     >
  //       About Noiz 3.0
  //     </Link>
  //   </li>
  // );

  const StreamWithUs = (
    <li className="menu-item">
      <Link
        activeClassName="active"
        to="/stream-with-us"
      >
        Stream With Us
      </Link>
    </li>
  );

  const AboutUs = (
    <li className="menu-item">
      <Link
        activeClassName="active"
        to="/about-us"
      >
        About Us
      </Link>
    </li>
  );

  const Store = (
    <li className="menu-item">
      <a href="https://store.noiz.gg/">
        Store
      </a>
    </li>
  );

  const SearchLight = (
    <li className="menu-item">
      <Link
        activeClassName="active"
        to="/searchlight"
      >
        Searchlight
      </Link>
    </li>
  );


  // Build a keyed menu list so we can easily filter by name from the `hide` array
  const keyedMenu = [
    { key: 'home', node: Home },
    // { key: 'about noiz 3.0', node: AboutNoiz3 },
    { key: 'stream with us', node: StreamWithUs },
    { key: 'about us', node: AboutUs },
    { key: 'searchlight', node: SearchLight },
    ...(showStore ? [{ key: 'store', node: Store }] : []),
  ];

  // Normalize hide to an array of lowercased strings for case-insensitive matching
  const hideList = Array.isArray(hide)
    ? hide.map((h) => String(h).toLowerCase())
    : typeof hide === 'string'
    ? [hide.toLowerCase()]
    : [];

  const renderMenu = keyedMenu
    .filter((item) => !hideList.includes(item.key))
    .map((item) => item.node);

  return (
    <nav className="basic-menu">
      <ul>
        {
          renderMenu
        }
        
        {/* <li className="menu-item">
          <Link
            activeClassName="active"
            to="/terms-of-use"
          >
            Terms of Use
          </Link>
        </li> */}

        {/* <li className="brands-btn common-btn">
          <Link
            activeClassName="active"
            to="/onboard"
          >
            Brands
          </Link>
        </li> */}
        <li className="creators-btn common-btn">
          <Link
            activeClassName="active"
            to="/sign-up"
          >
            {authenticated ? 'Quests' : 'Sign Up'}
          </Link>
        </li>
        {authenticated ? null :
          <li className="creators-btn common-btn">
            <Link
              activeClassName="active"
              to="/sign-in"
            >
              Sign In
            </Link>
          </li>}
      </ul>
    </nav>
  );
}

export default BasicMenu;
